'use client'
import styled from 'styled-components'
import { vw, mq } from '../styles'
import { Figure } from '@/components'

const Button = styled.button`
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${vw(60, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    width: 87px;
  }

  ${mq.greaterThan('tablet')} {
    display: none;
  }

  figure {
    height: ${vw(60, 'mobile')};
    width: ${vw(60, 'mobile')};
    z-index: 400;

    ${mq.greaterThan('nexus7')} {
      width: 87px;
    }
  }
`

const closeMenuIcon = {
  type: 'svg' as const,
  src: '/images/svg/i--burger-close.svg',
  alt: 'Close modal icon',
  size: { width: 60, height: 60 }
}


const burgerIcon = {
  type: 'svg' as const,
  src: '/images/svg/i--burger.svg',
  alt: 'Go back icon',
  size: { width: 60, height: 60 }
}


export const Burger = ({ menuOpen = false, onClick }) => {
  return (
    <Button type='button' onClick={onClick}>
      <Figure media={ menuOpen ? closeMenuIcon : burgerIcon} fill={false} />
    </Button>
  )
}
